import { useLazyQuery } from "@apollo/client/react";import { useEffect, useState } from "react";

import GET_VISITAS_COORDINACION, { adaptVisitasCoordinacion } from '../../../data/graphQL/queries/ControlVisitas/getVisitasCoordinacion';

export const useGetRows = ({ idEvaluacion, idProfesional, idTipoProfesional, idFrecuencia, mes, anio, fechaDesde, fechaHasta, idFiguraProfesional }) => {
  const [rows, setRows] = useState([]);
  const [rowsCoordinador, setRowsCoordinador] = useState([]);

  const [getVisitas, { data: dataVisitas, loading }] = useLazyQuery(GET_VISITAS_COORDINACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataVisitas) return;
    const adaptedData = adaptVisitasCoordinacion(dataVisitas);
    const dataProfesional = adaptedData.filter(visita => !visita?.desdeCoordinacion);
    const dataCoordinador = adaptedData.filter(visita => !!visita?.desdeCoordinacion);
    setRows(dataProfesional);
    setRowsCoordinador(dataCoordinador);
  }, [dataVisitas]);

  useEffect(() => {
    if (!idEvaluacion || isNaN(idEvaluacion) || !idProfesional || isNaN(idProfesional)
       || !idTipoProfesional || isNaN(idTipoProfesional) || !mes || !anio || isNaN(anio) || !fechaDesde || !fechaHasta) return;

    getVisitas({variables: { input: { idEvaluacion, idProfesional, idTipoProfesional, idFrecuencia, mes, anio, fechaDesde, fechaHasta, idFiguraProfesional } }});
  }, [idEvaluacion, idProfesional, idTipoProfesional, idFrecuencia, mes, anio, fechaDesde, fechaHasta, idFiguraProfesional]);

  const reload = () => {
    if (!idEvaluacion || isNaN(idEvaluacion) || !idProfesional || isNaN(idProfesional)
       || !idTipoProfesional || isNaN(idTipoProfesional) || !mes || !anio || isNaN(anio) || !fechaDesde || !fechaHasta) return;

    getVisitas({variables: { input: { idEvaluacion, idProfesional, idTipoProfesional, idFrecuencia, mes, anio, fechaDesde, fechaHasta, idFiguraProfesional } }});
  };

  return {
    reload,
    rows,
    rowsCoordinador,
    setRows,
    loading,
    totalCount: rows.length || 0
  };
};